export { default } from './DetailedCarBanner';
